/*eslint-disable*/

import React from 'react';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import Logo from '../assets/images/Motivar.svg';

// Styled Components
const BodyContainer = styled.div`
  margin: 0;
  padding: 20px;
  background-color: #f9fafb;

  * {
    background: transparent !important;
  }
`;

const ContentContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

const LogoContainer = styled.div`
  display: block;
  margin: 0 auto 3.125rem;
  width: 11.125rem;
  height: 2.375rem;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const Title = styled.h1`
  font-family: Arial, sans-serif !important;
  font-size: 26px !important;
  color: #000000 !important;
  line-height: 1.5;
  margin: 0;
`;

const Subtitle = styled.div`
  font-family: Arial, sans-serif !important;
  color: #595959 !important;
  font-size: 14px !important;
  line-height: 1.5;
  font-weight: bold;
`;

const Heading1 = styled.h2`
  font-family: Arial, sans-serif !important;
  font-size: 19px !important;
  color: #000000 !important;
  line-height: 1.5;
  margin: 0;
`;

const Heading2 = styled.h3`
  font-family: Arial, sans-serif !important;
  font-size: 17px !important;
  color: #000000 !important;
  line-height: 1.5;
  margin: 0;
`;

const BodyText = styled.div`
  color: #595959 !important;
  font-size: 14px !important;
  font-family: Arial, sans-serif !important;
  line-height: 1.5;
`;

const Link = styled.a`
  color: #3030F1 !important;
  font-size: 14px !important;
  font-family: Arial, sans-serif !important;
  word-break: break-word !important;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledList = styled.ul`
  list-style-type: square;
  margin-left: 20px;
  color: #595959;
  font-family: Arial, sans-serif;
  font-size: 14px;

  ul {
    list-style-type: circle;

    ul {
      list-style-type: square;
    }
  }
`;

const StyledListItem = styled.li`
  font-family: Arial, sans-serif;
  color: #595959;
  font-size: 14px;
  line-height: 1.5;
`;

const MsoNormal = styled.div`
  margin-bottom: 15px;
`;

const PrivacyPolicy = () => {
  return (
    <BodyContainer>
      <ContentContainer>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <RouterLink to="/">
            <img src={Logo} alt="Motivar Logo" style={{ height: '42px', objectFit: 'contain' }} />
          </RouterLink>
        </div>

        <div data-custom-class="body">
          <div align="center" style={{ textAlign: 'left' }}>
            <MsoNormal data-custom-class="title" style={{ lineHeight: '1.5' }}>
              <bdt class="block-component"><span style={{ fontSize: '19px' }}></span></bdt>
              <bdt class="question"><Title>PRIVACY POLICY</Title></bdt>
              <bdt class="statement-end-if-in-editor"></bdt>
            </MsoNormal>
            <MsoNormal data-custom-class="subtitle" style={{ lineHeight: '1.5' }}>
              <Subtitle>
                <strong>Last updated</strong> <bdt class="question"><strong>July 01, 2025</strong></bdt>
              </Subtitle>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.1' }}><br /></MsoNormal>
          </div>

          <div align="center" style={{ textAlign: 'left' }}>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                This privacy notice for <strong><bdt class="question">Edu-SupportTechnologies</bdt></strong>, doing business as <strong><bdt class="question">Motivar</bdt></strong> ('<strong>Company</strong>', '<strong>we</strong>', '<strong>us</strong>', or '<strong>our</strong>'), describes how and why we might collect, store, use, and/or share ('<strong>process</strong>') your information when you use our services ('<strong>Services</strong>'), such as when you:
              </BodyText>
            </MsoNormal>
            <StyledList>
              <StyledListItem>Visit our website at <span style={{ color: 'rgb(0, 58, 250)' }}><Link href="http://www.motivar.live" target="_blank">http://www.motivar.live</Link></span>, or any website of ours that links to this privacy notice</StyledListItem>
              <StyledListItem>Engage with us in other related ways, including any sales, marketing, or events</StyledListItem>
            </StyledList>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong>Questions or concerns?</strong> Reading this privacy notice will help you understand your privacy rights and choices. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at <bdt class="question">contact@motivar.live</bdt>.
              </BodyText>
            </MsoNormal>
          </div>

          <div align="center" style={{ lineHeight: '1' }}><br /></div>
          <div align="center" style={{ textAlign: 'left' }}>
            <MsoNormal data-custom-class="heading_1" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>TABLE OF CONTENTS</strong></Heading1>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#infocollect">1. WHAT INFORMATION DO WE COLLECT?</Link></MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#infouse">2. HOW DO WE PROCESS YOUR INFORMATION?</Link></MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#infoshare">3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</Link></MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#cookies">4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</Link></MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#inforetain">5. HOW LONG DO WE KEEP YOUR INFORMATION?</Link></MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#infosafe">6. HOW DO WE KEEP YOUR INFORMATION SAFE?</Link></MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#privacyrights">7. WHAT ARE YOUR PRIVACY RIGHTS?</Link></MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#DNT">8. CONTROLS FOR DO-NOT-TRACK FEATURES</Link></MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#policyupdates">9. DO WE MAKE UPDATES TO THIS NOTICE?</Link></MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><Link href="#contact">10. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</Link></MsoNormal>
          </div>

          <div align="center" style={{ textAlign: 'left' }}>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="infocollect" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>1. WHAT INFORMATION DO WE COLLECT?</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="heading_2" style={{ lineHeight: '1.5' }}>
              <Heading2><strong>Personal information you disclose to us</strong></Heading2>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><em>In Short:</em></strong><em> We collect personal information that you provide to us.</em>
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong>Personal Information Provided by You.</strong> The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:
              </BodyText>
            </MsoNormal>
            <StyledList>
              <StyledListItem>names</StyledListItem>
              <StyledListItem>phone numbers</StyledListItem>
              <StyledListItem>email addresses</StyledListItem>
              <StyledListItem>passwords</StyledListItem>
              <StyledListItem>billing addresses</StyledListItem>
            </StyledList>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.
              </BodyText>
            </MsoNormal>
          </div>

          <div align="center" style={{ textAlign: 'left' }}>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="infouse" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>2. HOW DO WE PROCESS YOUR INFORMATION?</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><em>In Short:</em></strong><em> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law.</em>
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                We process your personal information for a variety of reasons, depending on how you interact with our Services, including:
              </BodyText>
            </MsoNormal>
            <StyledList>
              <StyledListItem><strong>To facilitate account creation and authentication and otherwise manage user accounts.</strong> We may process your information so you can create and log in to your account, as well as keep your account in working order.</StyledListItem>
              <StyledListItem><strong>To deliver and facilitate delivery of services to the user.</strong> We may process your information to provide you with the requested service.</StyledListItem>
              <StyledListItem><strong>To save or protect an individual's vital interest.</strong> We may process your information when necessary to save or protect an individual's vital interest, such as to prevent harm.</StyledListItem>
            </StyledList>
          </div>

          <div align="center" style={{ textAlign: 'left' }}>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="infoshare" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><em>In Short:</em></strong><em> We may share information in specific situations described in this section and/or with the following third parties.</em>
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                We may need to share your personal information in the following situations:
              </BodyText>
            </MsoNormal>
            <StyledList>
              <StyledListItem><strong>Business Transfers.</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.</StyledListItem>
              <StyledListItem><strong>Affiliates.</strong> We may share your information with our affiliates, in which case we will require those affiliates to honour this privacy notice.</StyledListItem>
            </StyledList>
          </div>

          <div align="center" style={{ textAlign: 'left' }}>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="cookies" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><em>In Short:</em></strong><em> We may use cookies and other tracking technologies to collect and store your information.</em>
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store information. Specific information about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Notice.
              </BodyText>
            </MsoNormal>

            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="inforetain" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>5. HOW LONG DO WE KEEP YOUR INFORMATION?</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><em>In Short:</em></strong><em> We keep your information for as long as necessary to fulfil the purposes outlined in this privacy notice unless otherwise required by law.</em>
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a longer retention period is required or permitted by law (such as tax, accounting, or other legal requirements).
              </BodyText>
            </MsoNormal>
          </div>

          <div align="center" style={{ textAlign: 'left' }}>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="infosafe" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>6. HOW DO WE KEEP YOUR INFORMATION SAFE?</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><em>In Short:</em></strong><em> We aim to protect your personal information through a system of organisational and technical security measures.</em>
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                We have implemented appropriate and reasonable technical and organisational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure.
              </BodyText>
            </MsoNormal>

            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="privacyrights" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>7. WHAT ARE YOUR PRIVACY RIGHTS?</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><em>In Short:</em></strong><em> You may review, change, or terminate your account at any time.</em>
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                If you are located in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to complain to your Member State data protection authority or UK data protection authority.
              </BodyText>
            </MsoNormal>
          </div>

          <div align="center" style={{ textAlign: 'left' }}>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="DNT" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>8. CONTROLS FOR DO-NOT-TRACK FEATURES</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ('DNT') feature or setting you can activate to signal your privacy preference not to have data about your online browsing activities monitored and collected. At this stage no uniform technology standard for recognising and implementing DNT signals has been finalised.
              </BodyText>
            </MsoNormal>

            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="policyupdates" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>9. DO WE MAKE UPDATES TO THIS NOTICE?</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><em>In Short:</em></strong><em> Yes, we will update this notice as necessary to stay compliant with relevant laws.</em>
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                We may update this privacy notice from time to time. The updated version will be indicated by an updated 'Revised' date and the updated version will be effective as soon as it is accessible. We encourage you to review this privacy notice frequently to be informed of how we are protecting your information.
              </BodyText>
            </MsoNormal>

            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="heading_1" id="contact" style={{ lineHeight: '1.5' }}>
              <Heading1><strong>10. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</strong></Heading1>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                If you have questions or comments about this notice, you may email us at <bdt class="question">contact@motivar.live</bdt> or by post to:
              </BodyText>
            </MsoNormal>
            <MsoNormal style={{ lineHeight: '1.5' }}><br /></MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><bdt class="question">Edu-SupportTechnologies</bdt></strong>
              </BodyText>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong><bdt class="question">Nigeria</bdt></strong>
              </BodyText>
            </MsoNormal>
            <MsoNormal data-custom-class="body_text" style={{ lineHeight: '1.5' }}>
              <BodyText>
                <strong>Phone: <bdt class="question">09050731685</bdt></strong>
              </BodyText>
            </MsoNormal>
          </div>
        </div>
      </ContentContainer>
    </BodyContainer>
  );
};

export default PrivacyPolicy;